// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { ElistFilter } from "../Elist/ViewModels/elist-filter";
import { ElistOrder } from "../Elist/ViewModels/elist-order";

type SorFilterStateForNodeId = {
  sortFilterState: {
    sortBy: ElistOrder[];
    filters: ElistFilter[];
  };
  nodeId: string | undefined;
};

type SortFilterStates = {
  sortFilterStates: SorFilterStateForNodeId[];
};

const initialState: SortFilterStates = {
  sortFilterStates: [],
};

const emptySortFilter = {
  sortBy: [],
  filters: [],
};

export const sortOrderSlice = createSlice({
  name: "sortOrder",
  initialState,
  reducers: {
    setSortFilterForNode: (
      state,
      action: PayloadAction<SorFilterStateForNodeId>,
    ) => {
      if (
        action.payload.nodeId !== undefined &&
        action.payload.nodeId !== null
      ) {
        const existingState = state.sortFilterStates.find(
          (s) => s.nodeId === action.payload.nodeId,
        );
        if (existingState !== undefined) {
          state.sortFilterStates = state.sortFilterStates.map((s) => {
            if (s.nodeId === action.payload.nodeId) {
              // replace that item
              return action.payload;
            } else {
              // The rest haven't changed
              return s;
            }
          });
        } else {
          state.sortFilterStates = [
            ...state.sortFilterStates, // that contains all the old items
            action.payload, // and one new item at the end
          ];
        }
      }
    },
  },
});

export const { setSortFilterForNode } = sortOrderSlice.actions;

export const selectSortFilterState = (
  state: RootState,
  nodeId: string | undefined,
) => returnSortFilterstate(state, nodeId);

function returnSortFilterstate(state: RootState, nodeId: string | undefined) {
  if (nodeId === undefined || nodeId === null) {
    return emptySortFilter;
  }

  const exist = state.sortOrder.sortFilterStates.filter(
    (s) => s.nodeId === nodeId,
  );
  if (exist.length > 0) {
    return exist[0].sortFilterState;
  } else {
    return emptySortFilter;
  }
}

export default sortOrderSlice.reducer;
